import {
  CloseButton,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { ProcessViewModel } from "../../../models/Process";
import { DateTime } from "luxon";
import { crm } from "../../../theme";

const FinancialModal = ({
  p,
  isOpen,
  onClose,
  currency,
}: {
  p: ProcessViewModel;
  isOpen: boolean;
  currency?: string;
  onClose: () => void;
}) => {
  const formatterUsd = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: currency ?? "USD",
  });
  return (
    <Modal size="xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent fontFamily="Inter" borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader borderBottom={crm.border}>
          <Flex justifyContent="space-between">
            <Heading size="lg" fontWeight="semibold">
              Processo {p?.cvfRef}
            </Heading>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Flex flexDir="column">
            <Flex
              flexDir="column"
              gap="16px"
              backgroundColor="white"
              p="32px 16px"
            >
              <Flex>
                <Flex
                  flexDir="column"
                  gap="8px"
                  w={{ base: "200px", md: "300px" }}
                >
                  <Heading size="sm" fontWeight="semibold">
                    Termo de pagamento:
                  </Heading>

                  <Heading fontWeight="normal" size="md">
                    {p?.condition}
                  </Heading>
                </Flex>
                <Flex flexDir="column" gap="8px">
                  <Heading size="sm" fontWeight="semibold">
                    Total pago:
                  </Heading>

                  <Heading fontWeight="normal" size="md" color={crm.success}>
                    {formatterUsd.format(parseFloat(p?.totalPayed))}
                  </Heading>
                </Flex>
              </Flex>
              <Flex>
                <Flex
                  flexDir="column"
                  gap="8px"
                  w={{ base: "200px", md: "300px" }}
                >
                  <Heading size="sm" fontWeight="semibold">
                    Total a pagar:
                  </Heading>

                  <Heading size="md" color={crm.danger} fontWeight="normal">
                    {formatterUsd.format(parseFloat(p?.totalToPay))}
                  </Heading>
                </Flex>
                <Flex flexDir="column" gap="8px">
                  <Heading size="sm" fontWeight="semibold">
                    Total do processo:
                  </Heading>
                  <Heading size="md" fontWeight="normal">
                    {p?.totalInvoice}
                  </Heading>
                </Flex>
              </Flex>
            </Flex>
            <Flex flexDirection="column" gap="16px" p="16px">
              {p?.financialItems
                .sort((a, b) => a.intId - b.intId)
                .filter((f) => (f.valorPagamento?.length ?? 0) > 1)
                .map((f, index) => (
                  <Flex key={f.intId ?? index} flexDir="column" gap="16px">
                    <Flex>
                      <Flex
                        flexDir="column"
                        gap="8px"
                        w={{ base: "200px", md: "300px" }}
                      >
                        <Heading size="sm" fontWeight="semibold">
                          Taxa de câmbio ({index === 0 ? "Sinal" : "Saldo"})
                        </Heading>
                        <Flex flexDir="column" gap="16px">
                          <Heading size="md" fontWeight="normal">
                            {(f.taxaCambio?.length ?? 0) > 0
                              ? f.taxaCambio
                              : "Por definir"}
                          </Heading>
                        </Flex>
                      </Flex>
                      <Flex flexDir="column" gap="8px">
                        <Heading size="sm" fontWeight="semibold">
                          Data de câmbio
                        </Heading>
                        <Flex flexDir="column" gap="16px">
                          <Heading size="md" fontWeight="normal">
                            {f.dataCambio || f.dataPagamento
                              ? DateTime.fromISO(
                                  f.dataCambio
                                    ? f.dataCambio
                                    : f.dataPagamento
                                      ? f.dataPagamento
                                      : "",
                                ).toFormat("dd/LL/yyyy")
                              : "Por definir"}
                          </Heading>
                        </Flex>
                      </Flex>
                    </Flex>
                    <Flex>
                      <Flex
                        flexDir="column"
                        gap="8px"
                        w={{ base: "200px", md: "300px" }}
                      >
                        <Heading size="sm" fontWeight="semibold">
                          {index === 0 ? "Sinal" : "Saldo"} de pagamento
                        </Heading>
                        <Flex flexDir="column" gap="16px">
                          <Heading size="md" fontWeight="normal">
                            {f.valorPagamento}
                          </Heading>
                        </Flex>
                      </Flex>
                      <Flex flexDir="column" gap="8px">
                        <Heading size="sm" fontWeight="semibold">
                          Status
                        </Heading>
                        <Flex flexDir="column" gap="16px">
                          <Heading
                            size="sm"
                            fontWeight="normal"
                            borderWidth="1px"
                            p="12px"
                            borderRadius="8px"
                            textTransform="none"
                            backgroundColor={
                              (f.dataCambio && f.taxaCambio) ||
                              f.contratoCambio === "FINIMP"
                                ? "#F0FDF4"
                                : crm.brandSoft
                            }
                            borderColor={
                              (f.dataCambio && f.taxaCambio) ||
                              f.contratoCambio === "FINIMP"
                                ? crm.success
                                : crm.border
                            }
                            color={
                              (f.dataCambio && f.taxaCambio) ||
                              f.contratoCambio === "FINIMP"
                                ? crm.success
                                : crm.brand
                            }
                          >
                            {(f.dataCambio && f.taxaCambio) ||
                            f.contratoCambio === "FINIMP"
                              ? "Pago"
                              : f.dataPagamento
                                ? "Programado"
                                : "Ag. programação"}
                          </Heading>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                ))}
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default FinancialModal;
